import { IData } from '../fetchWidget'
import { IWidgetSettings } from '../../../reducers/widget'

export default function(response: IData, json2, error): IWidgetSettings[] {
  return response.items.map(item => ({
    color: item.widget_color,
    feeding_option: !!Number(item.show_food),
    feeding_option_bb: !!Number(item.show_food_bb),
    feeding_option_fb: !!Number(item.show_food_fb),
    feeding_option_hb: !!Number(item.show_food_hb),
    show_calendar: !!Number(item.show_calendar),
    no_reservation_online: !!Number(item.no_reservation_online),
    hide_url: !!Number(item.hide_link),
    kids_price: !!Number(item.show_kids_price),
    lang: item.language,
    policy_radio:
      Number(item.privacy_setting) === 1 ? 'policy_url' : 'policy_text',
    policy_text: item.privacy_text,
    policy_url: item.privacy_url,
    regulation_radio:
      Number(item.regulation_setting) === 1
        ? 'regulation_url'
        : 'regulation_text',
    regulation_text: item.regulation_text,
    regulation_url: item.regulation_url,
    subdomain:
      error || json2 === undefined ? item.subdomain : json2.items[0].subdomain,
    error: error,
    api_key: item.api_key,
    block_reservations: !!Number(item.block_reservations),
  }))
}
